import { PropsWithChildren, ReactNode } from 'react';
import { LocationAudience } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2/service.pb';
import type { Data } from '@frontend/segmented-bar';
import { ContentLoader, ModalControlModalProps, Tray } from '@frontend/design-system';
import { Cards } from '../cards';
import { LocationUsageAndAllotmentWithLimit } from '../type';
import { TrayFooter } from './tray-footer';
import { TrayHeader } from './tray-header';

type MessageAllotmentsFiltersProps = {
  audienceCounts?: LocationAudience[];
  chartData: Record<string, Data[]>;
  data?: LocationUsageAndAllotmentWithLimit[];
  isLoading: boolean;
  modalProps?: ModalControlModalProps;
  onBack: () => void;
  onSave: () => void;
  setData: (value: LocationUsageAndAllotmentWithLimit[]) => void;
  title?: ReactNode;
};

export const MessageAllotmentsFilters = ({
  audienceCounts,
  chartData,
  data,
  isLoading,
  modalProps,
  onBack,
  onSave,
  setData,
  title,
}: MessageAllotmentsFiltersProps) => {
  // Just need an example of what the legend will look like
  const first = chartData[Object.keys(chartData)[0]];

  return (
    <AllotmentsTray modalProps={modalProps}>
      <Tray.Header>
        <TrayHeader legendOptions={first} title={title} />
      </Tray.Header>
      <Tray.Body>
        {isLoading ? (
          <ContentLoader show />
        ) : (
          <Cards data={data} chartData={chartData} audienceCounts={audienceCounts} setData={setData} />
        )}
      </Tray.Body>
      <TrayFooter onSave={onSave} onBack={onBack} />
    </AllotmentsTray>
  );
};

type AllotmentsTrayProps = PropsWithChildren<{
  modalProps?: ModalControlModalProps;
}>;

const AllotmentsTray = ({ children, modalProps }: AllotmentsTrayProps) => {
  return modalProps ? (
    <Tray {...modalProps} width='medium'>
      {children}
    </Tray>
  ) : (
    children
  );
};
